import { graphql } from 'react-relay';

export const PROMOTIONAL_CODES_QUERY = graphql`
  query PromotionalCodeQuery {
    adminPromotionalCodes {
      id
      code
      plan
      planName
      planValueCents
      discountType
      discountValue
      discountDuration
      durationMonths
      appliesTo
      isActive
      maxUses
      currentUses
      expiresAt
      createdAt
    }
  }
`;
